var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.067.664l.095.083L6 4.586 9.838.747a1 1 0 011.498 1.32l-.083.095L7.414 6l3.491 3.49a1 1 0 01-1.32 1.498l-.094-.083L6 7.414l-3.49 3.491a1 1 0 01-1.498-1.32l.083-.094 3.49-3.492L.747 2.162A1 1 0 011.966.595l.101.07z",
  fill: "#A3A3A3"
})));

export default SvgIconClose;